import * as React from 'react';
import { LanguageCode } from '../../Translator';
import { ElectionContainer } from '../election/ElectionContainer';
import { DocumentTitle } from '../DocumentTitle';
import { QuestionMark } from '../ui/QuestionMark';
import { ElectionNameAndCandidateName } from './ElectionNameAndCandidateName';
import { CandidateState } from '../../_generatedTypes.g';
import { CandidateProfile } from './CandidateProfile';

export const CandidatePage = (props: { children?: React.ReactNode, pageTitle: string, helpText?: React.JSX.Element, lang: LanguageCode, candidate: CandidateState }) =>
    <ElectionContainer candidateId={props.candidate.CandidateId}>
        <div>
            <DocumentTitle title={props.pageTitle}/>
            <h1>{props.pageTitle}</h1>
            <div>
                <QuestionMark>{props.helpText}</QuestionMark>
                <div id={`Candidate-CandidateDetails-${props.candidate.CandidateId}`}>
                    <ElectionNameAndCandidateName candidateId={props.candidate.CandidateId}/>
                    <CandidateProfile candidate={props.candidate} lang={props.lang}/>
                </div>
            </div>
            {props.children}
        </div>
    </ElectionContainer>
